import _get from "lodash.get";
import { LoggerBus } from "@app/utils/logger-bus";

const loggerFormat = "[store::errors]";
const errorStore = {
  namespaced: true,
  state: {
    errors: [],
    error: null
  },
  mutations: {
    setErrors(state, payload) {
      state.errors.push(payload);
    },
    setError(state, payload) {
      state.error = payload;
    },
    updateErrorState(state, newErrorState) {
      state.errors = newErrorState;
    },
    clearErrors(state) {
      state.errors = [];
      state.error = null;
    }
  },
  actions: {
    addNewError({ commit, state, dispatch }, error) {
      commit("clearErrors");
      LoggerBus.$log.error(loggerFormat, `here`, error);

      const errorResponse = _get(error, "response", {});

      if (errorResponse.status !== 422) {
        return dispatch("errorHandler", error);
      }

      const unparsedErrors = _get(errorResponse, "data.errors");

      const listOfErrors = Object.values(unparsedErrors).reduce(
        (acc, listOfErrors) => [...acc, ...listOfErrors],
        []
      );

      const title = _get(errorResponse, "data.message");

      const newError = {
        title,
        id: state.errors.length + 1,
        messages: listOfErrors
      };

      commit("setErrors", newError);
    },
    removeErrorById({ commit, state }, errorId) {
      const newState = state.errors.filter(error => error.id !== errorId);

      commit("updateErrorState", newState);
    },
    clearErrors({ commit }) {
      commit("clearErrors");
    },
    errorHandler({ commit }, error) {
      LoggerBus.$log.error(loggerFormat, error.message, error);
      const response = error.response;
      const { status, statusText } = response;

      const data = response.data;
      const { message, exception } = data;
      commit("setError", { status, statusText, message, exception });
    }
  },
  getters: {
    getErrors(state) {
      return state.errors;
    },
    error(state) {
      return state.error;
    }
  }
};

export default errorStore;
